import { Autocomplete, Checkbox, Grid, TextField, Typography } from "@mui/material"
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import CheckBoxIcon from '@mui/icons-material/CheckBox'

export const InputAutoCompleteCadastroEvento = ({ handleFiltroEventos, condominiosList, dados, disabled }) => {
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
    const checkedIcon = <CheckBoxIcon fontSize="small" />
    return (
        <Grid>
            <Typography sx={{ color: '#6D6A70', width: "100%" }}>Selecione os condominios vinculados ao evento:</Typography>
            <Autocomplete
                sx={{ maxWidth: "100%", maxHeight: '100px', overflowY: 'scroll', backgroundColor: 'white', borderRadius: '5px', '.MuiOutlinedInput-notchedOutline': { border: 'none' } }}
                multiple
                id="checkboxes-tags-demo"
                options={condominiosList}
                noOptionsText="Nenhum condominio para selecionar!"
                disableCloseOnSelect
                value={dados}
                disabled={disabled}
                defaultValue={dados}
                isOptionEqualToValue={(option, value) => option.id_central == value.id_central}
                onChange={(e, newValue) => handleFiltroEventos(e, newValue)}
                getOptionLabel={(option) => option.id_central + "-" + option.nome}
                ListboxProps={
                    {
                        style: {
                            maxHeight: '200px'
                        }
                    }
                }
                renderOption={(props, option, { selected }) => (
                    <li {...props}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                        />
                        { option.id_central + "-" + option.nome}
                    </li>
                )}
                renderInput={(params) => (
                    <TextField {...params} label="" placeholder="condominios" />
                )}
            />
        </Grid>
    )
}
